<div nz-row [nzGutter]="24" [nzJustify]="'center'" style="margin-right: auto; margin-left: auto; padding-right: 20px; padding-left: 20px;">
  <nz-steps [nzCurrent]="selectedTab" (nzIndexChange)="onStepChange($event)">
    <nz-step
      *ngFor="let step of completedSteps; let i = index"
      [nzTitle]="getStepTitle(i)"
      [nzDescription]="getStepDescription(i)"
      [nzDisabled]="i>1 && !completedSteps[i-1]"></nz-step>
  </nz-steps>
<nz-tabset [nzSize]="'large'" [(nzSelectedIndex)]="selectedTab" style="flex: 1 1 auto;"  >
  <nz-tab nz-col >
    <form nz-form [nzLayout]="'horizontal'">
      <nz-spin [nzSpinning]="isLoading">
        <h3>CAPTURE BEFORE REQUESTING AUTH</h3>
        <ng-container *ngFor="let field of authData.fields">
          <nz-form-item>
            <nz-form-label [nzSpan]="6" [nzRequired]="field.isRequired" style="margin-right: 10px">{{ field.fleetAuthFieldName }} </nz-form-label>
            <nz-form-control [nzErrorTip]="field.fleetAuthFieldName + ' is required'">
              <nz-input-group [nz-tooltip]="field.tooltipText" [nzTooltipPlacement]="'top'" >
                <input *ngIf="field.dataType==1 || field.dataType == 2" nz-input [type]="'text'" [id]="field.fleetAuthFieldName" [placeholder]="field.fleetAuthFieldName" [(ngModel)]="field.fleetAuthFieldValue" [name]="field.fleetAuthFieldName" [required]="field.isRequired" [readonly]="authData.isLocked || authData.dtEmailed" (ngModelChange)="isSaved=false">
                  <input *ngIf="field.dataType==3 && !field.fleetAuthFieldValueId && !field.fleetAuthFieldValue"
                    nz-input
                    type="file"
                    [id]="field.fleetAuthFieldName"
                    [placeholder]="field.fleetAuthFieldName"
                    [name]="field.fleetAuthFieldName"
                    (change)="onFileSelected($event, field)" 
                    accept="image/*,application/pdf"
                    [disabled]="authData.isLocked || !!authData.dtEmailed || isFieldUploading(field.fleetAuthFieldName)"
                    (ngModelChange)="isSaved=false">
                    <!-- Upload progress indicator -->
                    <div *ngIf="isFieldUploading(field.fleetAuthFieldName)" class="upload-progress">
                      <nz-spin nzSimple></nz-spin>
                      <span style="margin-left: 8px;">Uploading...</span>
                    </div>
                  <input *ngIf="field.dataType==4"
                    nz-input
                    type="file"
                    [id]="field.fleetAuthFieldName"
                    [placeholder]="field.fleetAuthFieldName"
                    [name]="field.fleetAuthFieldName"
                    (change)="onFileSelected($event, field)" 
                    accept="image/*,application/pdf"
                    [disabled]="authData.isLocked || !!authData.dtEmailed || isFieldUploading(field.fleetAuthFieldName)"
                    (ngModelChange)="isSaved=false"
                    multiple>
                    <div *ngIf="isFieldUploading(field.fleetAuthFieldName)" class="upload-progress">
                    <nz-spin nzSimple></nz-spin>
                    <span style="margin-left: 8px;">Processing files...</span>
                  </div>
                  <div *ngIf="field.fleetAuthFieldValue && !isFieldUploading(field.fleetAuthFieldName) && (field.dataType==3 || field.dataType==4)" 
                  class="file-count">
                  {{ field.fleetAuthFieldValue.length  }} file(s) uploaded
                  </div>
              </nz-input-group>
            </nz-form-control>
              <!-- Validation error display -->
            <div *ngIf="getFieldValidationError(field.fleetAuthFieldName)" 
                class="validation-error">
              {{ getFieldValidationError(field.fleetAuthFieldName) }}
            </div>
            <button nz-button  *ngIf="(field.dataType==3 || field.dataType==4) && field.fleetAuthFieldValueId != null && !field.fleetAuthFieldValue " (click)="openFile(quote.quoteId, field)" style="cursor: pointer; margin-left: 10px;" nz-tooltip="Click to view image" [nzTooltipPlacement]="'top'">
              View Image <span nz-icon nzType="file-jpg" nzTheme="outline" style="margin-left: 5px"> </span>
            </button>
            <!-- For dataType 4, display images below the input; otherwise, to the right -->
            <ng-container *ngIf="field.dataType == 4; else rightOfInput">
              <div nz-row style="width: 100%; margin-top: 10px;" nzJustify="end">
                <div *ngFor="let item of field.fleetAuthFieldValue">
                  <img *ngIf="item" [src]="item" alt="{{field.fleetAuthFieldName}}" style="width: 40px; height: auto; margin-right: 10px;">
                </div>
              </div>
            </ng-container>
            <ng-template #rightOfInput>
              <div style="display: inline-block; vertical-align: middle;">
                <div *ngFor="let item of field.fleetAuthFieldValue">
                  <img *ngIf="(field.dataType==3 || field.dataType==4) && item" [src]="item" alt="{{field.fleetAuthFieldName}}" style="width: 40px; height: auto; margin-left: 10px;">
                </div>
              </div>
            </ng-template>
          </nz-form-item>
        </ng-container>
        
            <nz-modal 
              [(nzVisible)]="isImageViewerVisible" 
              [nzTitle]="currentField?.fleetAuthFieldName" 
              [nzFooter]="null" 
              (nzOnCancel)="closeImageViewer()" 
              nzWidth="800px"
              [nzBodyStyle]="{ padding: '20px' }">
              
              <div *nzModalContent>
                <nz-spin [nzSpinning]="isLoading">
                <div *ngIf="selectedImages && selectedImages.length > 0; else noImages" 
                     style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: space-evenly;">
                  
                  <div *ngFor="let image of selectedImages" 
                       style="position: relative; flex: 0 0 auto;">
                    <button 
                      nz-button 
                      nzType="primary" 
                      nzShape="circle" 
                      nzDanger 
                      nzSize="small"
                      (click)="removeImage(image)" 
                      style="position: absolute; top: 5px; right: 5px; z-index: 10;">
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                    </button>
                    <ng-container *ngIf="image.endsWith('.pdf') || image.startsWith('data:application/pdf'); else imageBlock">
                      <embed 
                        [src]="sanitizer.bypassSecurityTrustResourceUrl(image)" 
                        type="application/pdf" 
                        width="250px" 
                        height="300px" />
                    </ng-container>
                    
                    <ng-template #imageBlock>
                      <img 
                        [src]="sanitizer.bypassSecurityTrustResourceUrl(image)" 
                        [alt]="currentField?.fleetAuthFieldName" 
                        style="width: 250px; height: auto; max-height: 300px; object-fit: contain;"
                        (click)="openImageInNewTab(image)" 
                        nz-tooltip="Click to open in new tab"/>
                    </ng-template>
                  </div>
                </div>
                
                <ng-template #noImages>
                  <div style="text-align: center; padding: 40px; color: #999;">
                    <p>No images to display</p>
                  </div>
                </ng-template>
                </nz-spin>
              </div>
            </nz-modal>


      <nz-form-item *ngIf="authData.fleetAuthType === 2 && authData.fleetAuthSubType === 2">
        <nz-form-label [nzSpan]="6">Add Email Addresses</nz-form-label>
        <nz-form-control>
          <nz-input-group [nzAddOnAfter]="addOnAfterTemplate" [nzSize]="'large'">
            <input nz-input id="email" placeholder="Enter email addresses separated by a comma" [(ngModel)]="emails" name="email" [readonly]="authData.isLocked || authData.dtEmailed">
            <ng-template #addOnAfterTemplate>
              <button nz-button (click)="addEmail()" [disabled]="authData.isLocked || !!authData.dtEmailed">Add</button>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="authData.fleetAuthType === 2 && authData.fleetAuthSubType === 2">  
          <p>An email will be sent with all required info to {{authData.emailAddresses}}</p>
      </nz-form-item>
        <div nz-row [nzJustify]="'space-between'">
          
          <button nz-button nzType="primary" (click)="saveFleetAuthFields()" [disabled]="authData.isLocked || !!authData.dtEmailed || !areAllRequiredFieldsFilled() ">Save</button>
          <!--e-Auth-->
          <button nz-button nzType="primary" (click)="onClickSubmitEAuth()" [disabled]="isLoading || authData.isLocked || !areAllRequiredFieldsFilled()" *ngIf="authData.fleetAuthType === 1">
            <span *ngIf="!isSaved">Save and&nbsp;</span>Submit eAuth
          </button>
          <!--Email Auth-->
          <button nz-button nzType="primary" (click)="sendEmail()" [disabled]="isLoading || authData.isLocked || !areAllRequiredFieldsFilled()" *ngIf="authData.fleetAuthType === 2 && authData.fleetAuthSubType === 2">
            <span *ngIf="!isSaved">Save and&nbsp;</span>Send Email
          </button>
          <!--Call Auth-->
          <button nz-button nzType="primary" (click)="sendEmail()" [disabled]="isLoading || authData.isLocked || !areAllRequiredFieldsFilled()" *ngIf="authData.fleetAuthType === 2 && authData.fleetAuthSubType === 1">
            <span *ngIf="!isSaved">Save and&nbsp;</span> Proceed
          </button>

        </div>
        <div *ngIf="hasLargeFileFields()" nz-row [nzJustify]="'start'" style="margin-top: 10px;">
          <p style="color: grey">*Please note saving/submitting may take up to 20 seconds due to large amount of files</p>
        </div>

      </nz-spin>
    </form>
    
  </nz-tab>

  <nz-tab nz-col [nzDisabled]="!authData.dtEmailed">
    <div *ngIf="authData.fleetAuthType === 2">
    <div nz-row [nzJustify]="'space-around'" >
      <h3 *ngIf="quote.authSubType === 1">Contact the call centre to obtain authorisation</h3>
      <h3 *ngIf="quote.authSubType === 2">Authorization sent successful</h3>
    </div>
      <div *ngIf="quote.authSubType === 2">
        <div nz-row>
            <h6 style="margin-right:15px">Email Sent: </h6><h6 [style]="authData.dtEmailed ? 'color: green ' : 'color: red'">{{authData.dtEmailed ? 'Yes' : 'No'}}</h6>
        </div>
        <h6>Time since email: {{calculateTimeSinceEmailed(authData.dtEmailed)}}</h6>
              <div nz-row [nzJustify]="'space-between'">
          <div >
            <h6>Auth Status : 
              <span *ngIf="authData.isAuthorised === null" style="color: orange;">{{authData.authStatus}}</span>
              <span *ngIf="authData.isAuthorised !== null"[style]="authData.isAuthorised ? 'color: green ' : 'color: red'">{{authData.authStatus}}</span>
            </h6>
          </div>
        </div>
        <p *ngIf="authData.fleetAuthSubType === 1">After the Call Centre is contacted and authorisation is approved or declined, fill in the form below.</p>
        <p *ngIf="authData.fleetAuthSubType === 2 && isEmailedMoreThanFiveMinutesAgo(authData.dtEmailed)">'No response received, please contact call centre</p>
      </div>
      <div *ngIf="quote.authSubType === 1 || isEmailedMoreThanFiveMinutesAgo(authData.dtEmailed)">
        <h4>Call Centre Number: {{authData.callCentreNumber}}</h4>
        <h4>Merchant Number: {{authData.merchantNumber}}</h4>
        <h6>Reference: {{ quote.quoteRef }}  </h6>
      </div>
      <form nz-form style=" padding: 10px;" >
        <nz-form-item *ngIf="authData.fleetAuthType === 2 && authData.fleetAuthSubType === 1">
        <nz-form-label [nzSpan]="6">Add additional recipients</nz-form-label>
        <nz-form-control>
          <nz-input-group [nzAddOnAfter]="addOnAfterTemplate" [nzSize]="'large'">
            <input nz-input id="email" placeholder="Enter email addresses separated by a comma" [(ngModel)]="newEmail" name="email">
            <ng-template #addOnAfterTemplate>
              <button nz-button (click)="resendEmail()"[disabled]="!newEmail && newEmail.length === 0">Send</button>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
          
      <nz-form-item style="padding: 10px; margin-bottom: 10px;" *ngIf="authData.fleetAuthSubType === 1">
        <nz-input-group style="margin-right: auto; display: flex; align-items: center; justify-content: space-between;">
          <nz-form-label style="margin-right: auto;" nzRequired [nzNoColon]="true">
            <h6 class="span-emphasis">Update Authorisation Status as received from Call Centre:</h6>
          </nz-form-label>
          <nz-radio-group nzSize="large" [(ngModel)]="selectedAuthorisation" nzButtonStyle="solid" name="isAuthorised" [disabled]="!authData.dtEmailed || !!authData.isAuthorised">
            <label nz-radio-button [nzValue]="true">Approve</label>
            <label nz-radio-button [nzValue]="false">Decline</label>
          </nz-radio-group>
        </nz-input-group>
      </nz-form-item>

      <nz-form-item *ngIf="selectedAuthorisation" style=" padding: 10px; margin-bottom: 10px;">
        <nz-form-label [nzSpan]="6" [nzRequired]="selectedAuthorisation">Auth Number</nz-form-label>
        <nz-form-control [nzErrorTip]="'Auth Number is required'">
          <nz-input-group >
        
        <input nz-input [type]="'text'" id="authNumber" placeholder="Enter auth number" [(ngModel)]="authData.authNumber" name="authNumber" [required]="authData.isAuthorised" [readonly]="authData.isAuthorised != null">
          </nz-input-group>
          </nz-form-control>
        </nz-form-item>
    
        <nz-form-item *ngIf="selectedAuthorisation != null " style=" padding: 10px; margin-bottom: 10px;">
          <nz-form-label [nzSpan]="6" [nzRequired]="authData.isAuthorised == false">Message</nz-form-label>
          <nz-form-control [nzErrorTip]="authData.isAuthorised == false ? 'Message is required' : ''">
            <nz-input-group> 
              <input 
              nz-input 
              id="authMessage" 
              placeholder="Enter auth message" 
              [(ngModel)]="authData.message" 
              [required]="authData.isAuthorised == false" 
              name="authMessage"
              [readonly]="authData.isAuthorised != null">
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
    
    
        <nz-form-item *ngIf="selectedAuthorisation" style=" padding: 10px; margin-bottom: 10px;" [nzJustify]="'space-between'">
          <nz-form-label [nzRequired]="selectedAuthorisation">Upload Auth Letter</nz-form-label>
          <nz-form-control [nzErrorTip]="'Auth Letter is required'">
            <nz-input-group nz-tooltip="Upload auth letter" [nzTooltipPlacement]="'top'">
              
              <input nz-input type='file' id="authLetter" placeholder="Upload auth letter" (change)="onLetterUpload($event)" [disabled]="authData.isAuthorised != null">
            </nz-input-group>
            
          </nz-form-control>
          <button *ngIf="authData.authLetterBase64" nz-button nzType="primary" (click)="downloadFile(authData.authLetterBase64, 'Auth_Letter')" [nz-tooltip]="authData.authLetterBase64 ? 'Download Auth Letter' : 'No Auth Letter'" style="margin-left: 10px;"><span nz-icon nzType="download" nzTheme="outline"></span></button>
        </nz-form-item>
      </form>
      <div nz-row [nzJustify]="'center'" style="margin-top: 20px;">
        <button nz-button nzType="primary" [disabled]="!canSubmit() || selectedAuthorisation == null" (click)="authorise()">Confirm Authorisation</button>
      </div>
    </div>
    <!-- e auth-->
    <div *ngIf="authData.fleetAuthType === 1">
      <div nz-row>
        <h6 style="margin-right:15px">Auth Sent: </h6>
        <h6 [style]="authData.dtEmailed ? 'color: green ' : 'color: red'">{{authData.dtEmailed ? 'Yes' : 'No'}}</h6>
      </div>
      <h6>Time since Auth: {{calculateTimeSinceEmailed(authData.dtEmailed)}}</h6>
      <div nz-row [nzJustify]="'center'" style="margin-top: 20px;">
        <button nz-button nzType="primary" [disabled]="authData.stateId >= 3" (click)="onClickCheckEAuthStatus()" [nzLoading]="isLoading">Check Authorisation Status</button>
        
      </div>
    </div>
  </nz-tab>


  <nz-tab nz-col [nzDisabled]="!authData.dtEmailed">
    <div nz-row [nzJustify]="'center'" style="padding: 20px;">
      <h3>Summary</h3>
    </div>
    <div nz-row [nzJustify]="'space-between'" style="margin-bottom: 10px;">
      <div>
        <h4>Authorisation Status: {{authData.authStatus}}</h4>
        <h4 *ngIf="authData.isAuthorised">Authorisation Number: {{authData.authNumber}}</h4>
        <h4 *ngIf="!authData.isAuthorised">Message: {{authData.message}}</h4>
      </div>
    </div>
    <div nz-row [nzJustify]="'center'" style="margin-top: 20px;">
      <button *ngIf="authData.authLetterBase64" nz-button nzType="primary" (click)="downloadFile(authData.authLetterBase64, 'Auth_Letter')" [nz-tooltip]="'Download Auth Letter'" >Download Auth Letter</button>
    </div>
    <div nz-row [nzJustify]="'center'" style="margin-top: 20px;" >
      <button nz-button nzType="primary" *ngIf="authData.fleetAuthType === 1 && authData.isAuthorised === false" (click)="onClickConvertToEmailAuth()" [nzLoading]="isLoading" [disabled]="isLoading" [nz-tooltip]="'Start the basic Email Authorisation Flow'" >Convert to Email Auth</button>
      <button nz-button nzType="primary" *ngIf="authData.fleetAuthType === 1 && authData.isAuthorised === true" (click)="continueQuote()" [nzLoading]="isLoading">Continue</button>
    </div>
  </nz-tab>


    </nz-tabset>
</div>

